"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var isTextTruthy = function isTextTruthy(val) {
  return val !== undefined && val !== null && val.toString() !== '';
};

function generateUniqueId(name, placeholder, label) {
  // Build a unique ID for this field in case one was not provided.
  // Logic from https://github.com/callemall/material-ui/blob/master/src/TextField/TextField.js
  var randomNumber = Math.floor(Math.random() * 0xffff);
  var uniqueId = "".concat(name, "-").concat(placeholder, "-").concat(label, "-").concat(randomNumber);
  return uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
}

var TextField = _react["default"].forwardRef(function (_ref, ref) {
  var autoFocus = _ref.autoFocus,
      bsStyle = _ref.bsStyle,
      className = _ref.className,
      disabled = _ref.disabled,
      helpText = _ref.helpText,
      id = _ref.id,
      inputStyle = _ref.inputStyle,
      label = _ref.label,
      name = _ref.name,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onClick = _ref.onClick,
      onFocus = _ref.onFocus,
      onKeyDown = _ref.onKeyDown,
      placeholder = _ref.placeholder,
      required = _ref.required,
      rightAddon = _ref.rightAddon,
      style = _ref.style,
      type = _ref.type,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["autoFocus", "bsStyle", "className", "disabled", "helpText", "id", "inputStyle", "label", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "placeholder", "required", "rightAddon", "style", "type", "value"]);

  var _useState = (0, _react.useState)(isTextTruthy(value)),
      _useState2 = _slicedToArray(_useState, 2),
      _float = _useState2[0],
      setFloat = _useState2[1];

  var _useState3 = (0, _react.useState)(generateUniqueId(name, placeholder, label)),
      _useState4 = _slicedToArray(_useState3, 1),
      uniqueId = _useState4[0];

  (0, _react.useEffect)(function () {
    setFloat(isTextTruthy(value));
  }, [setFloat, value]);

  var handleBlur = function handleBlur(e) {
    setFloat(isTextTruthy(value));
    onBlur && onBlur(e);
  };

  var handleFocus = function handleFocus(e) {
    setFloat(true);
    onFocus && onFocus(e);
  };

  var inputId = id || uniqueId;
  var isTextArea = type === 'textarea';
  var wrapperClassNames = ['form-group', className];
  label && _float && wrapperClassNames.push('form-group-active');
  required && wrapperClassNames.push('required');
  bsStyle && wrapperClassNames.push('has-' + bsStyle);
  disabled && wrapperClassNames.push('disabled');

  var inputProps = _objectSpread({}, rest, {
    autoFocus: autoFocus,
    className: 'form-control',
    disabled: disabled,
    id: inputId,
    name: name,
    onBlur: handleBlur,
    onChange: onChange,
    onClick: onClick,
    onFocus: handleFocus,
    onKeyDown: onKeyDown,
    placeholder: placeholder,
    ref: ref,
    required: required,
    style: inputStyle,
    value: value
  });

  if (!isTextArea) {
    inputProps.type = type;
  }

  var inputElement = isTextArea ? _react["default"].createElement("textarea", inputProps) : _react["default"].createElement("input", inputProps);
  var labelElement = label ? _react["default"].createElement("label", {
    className: "control-label".concat(isTextArea ? ' textarea-label' : ''),
    htmlFor: inputId
  }, label) : null;
  return _react["default"].createElement("div", {
    className: wrapperClassNames.join(' '),
    style: style
  }, _react["default"].createElement("div", {
    className: "input-group",
    style: {
      width: '100%',
      zIndex: 0
    }
  }, inputElement, labelElement, rightAddon && _react["default"].createElement("span", {
    className: "input-group-btn"
  }, rightAddon)), helpText ? _react["default"].createElement("small", {
    className: "help-block"
  }, helpText) : null);
});

TextField.displayName = 'TextField';
TextField.defaultProps = {
  autoFocus: false,
  className: '',
  disabled: false,
  required: false,
  type: 'text',
  value: ''
};
TextField.propTypes = {
  name: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(['text', 'number', 'password', 'url', 'search', 'email', 'tel', 'textarea']),
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  label: _propTypes["default"].node,
  placeholder: _propTypes["default"].string,
  helpText: _propTypes["default"].node,
  id: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  autoFocus: _propTypes["default"].bool,
  bsStyle: _propTypes["default"].oneOf(['success', 'warning', 'error', '']),
  className: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  style: _reactStyleProptype["default"],
  inputStyle: _reactStyleProptype["default"],
  rightAddon: _propTypes["default"].element
};
var _default = TextField;
exports["default"] = _default;